/**
 * Design System - Class Names Utility
 *
 * Utility functions for managing conditional class names.
 */

import clsx from 'clsx';

/**
 * Combines class names conditionally
 * @param {...any} classes - Class names to combine
 * @returns {string} Combined class names
 */
export function cn(...classes) {
  return clsx(classes);
}

/**
 * Creates a className function for conditional styling
 * @param {Object} variants - Variant configurations
 * @param {Object} defaultVariants - Default variant values
 * @returns {Function} Function that returns class names based on props
 */
export function createVariants(variants, defaultVariants = {}) {
  return (props = {}) => {
    const selectedVariants = { ...defaultVariants, ...props };

    const classes = Object.keys(selectedVariants).map(variantKey => {
      const variantValue = selectedVariants[variantKey];
      const variantConfig = variants[variantKey];

      if (!variantConfig) return null;

      return variantConfig[variantValue] || null;
    });

    return cn(...classes, props.className);
  };
}

export default cn;
